import { styled } from '@mui/system'
import { colors, fontSizes } from '../consts'

type DoughnutOuterConProps = {
  height?: number
}

export const DoughnutOuterCon = styled('div')<DoughnutOuterConProps>(({ height, theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: colors.gray.gray60,
    height: height ?? 350,
    [theme.breakpoints.down('md')]: {
        margin: theme.spacing(5, 0),
        height: height ? height * 0.7 : 235,
    },
  }))

export const DoughnutCon = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
}))

export const InnerDataCon = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  '& .dataItem': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: theme.spacing(0, 1.5),
    '& .metric': {
      color: colors.white,
      fontSize: fontSizes.medium,
      margin: theme.spacing(0, 0),
      fontWeight: 700,
      [theme.breakpoints.down('md')]: {
        fontSize: fontSizes.small,
      },
    },
    '& .title': {
      color: colors.gray.gray20,
      fontSize: fontSizes.small,
      fontWeight: 700,
      margin: theme.spacing(0.5, 0),
      [theme.breakpoints.down('md')]: {
        fontSize: fontSizes.xSmall,
      },
    },
  },
}))
